import Model from '@/models/Model'

export default class PchPurchaseOrder extends Model {
    resource() {
        return 'pch_purchase_order_state'
    }
}